import React from "react";

function MainContainer({ children }) {
  return (
    <section className="bg_gray2 main-wrapper vw-100 vh-100 overflow-hidden">
      <div className="position-relative">

        {children}

      </div>
    </section>
  );
}

export default MainContainer;
